import React, { useState } from "react";
import { Link } from "react-router-dom";
import { loginUser } from "../api/api";
import PasswordInput from "../components/PasswordInput";
import { consumeSessionExpiredMessage, saveAuthSession } from "../utils/auth";
import "./Auth.css";

const LOGO_SRC = "/logoamicale.png";

function Login() {
  const [matricule, setMatricule] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  React.useEffect(() => {
    const message = consumeSessionExpiredMessage();
    if (message) setError(message);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      setLoading(true);
      const { data } = await loginUser(matricule, password);
      saveAuthSession(data);
      window.location.href = "/dashboard";
    } catch (err) {
      setError("Matricule ou mot de passe incorrect.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="auth-page">
      <section className="auth-showcase">
        <div className="auth-logo-orbit">
          <img src={LOGO_SRC} alt="Logo Amicale Autoroutes" />
        </div>
        <span className="auth-eyebrow">Amicale Autoroutes</span>
        <h1>Un espace plus clair pour gerer vos services amicale.</h1>
        <p>
          Consultez votre profil, vos evenements, vos engagements et votre historique
          dans une interface simple, moderne et adaptee au logo.
        </p>
        <div className="auth-feature-row">
          <span>Quota</span>
          <span>Evenements</span>
          <span>Engagements</span>
        </div>
      </section>

      <section className="auth-panel">
        <div className="auth-card">
          <div className="auth-card-header">
            <img src={LOGO_SRC} alt="" />
            <div>
              <span className="auth-eyebrow">Connexion adherent</span>
              <h2>Bienvenue</h2>
            </div>
          </div>

          {error && <div className="auth-alert">{error}</div>}

          <form onSubmit={handleSubmit} className="auth-form">
            <label>
              <span>Matricule</span>
              <input
                placeholder="8 chiffres"
                value={matricule}
                onChange={(e) => setMatricule(e.target.value.replace(/\D/g, ""))}
                maxLength={8}
                inputMode="numeric"
                autoComplete="username"
              />
            </label>

            <label>
              <span>Mot de passe</span>
              <PasswordInput
                placeholder="Votre mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </label>

            <button type="submit" disabled={loading}>
              {loading ? "Connexion..." : "Se connecter"}
            </button>
          </form>

          <div className="auth-switch">
            Vous etes fournisseur ?
            <Link to="/fournisseur/login"> Connexion fournisseur</Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Login;
